import { _ as __rest } from '../../../tslib.es6-c563c1dd.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Hidden, List, ListSubheader, Link as Link$1, Drawer } from '@mui/material';
import 'moment';
import { hasDireito } from '../../../utils/direitos.js';
import '@mui/icons-material/Close';
import '../../../components/CodeReader/BarcodeScanner.js';
import '../../../components/CodeReader/QRCodeScanner.js';
import '../../../components/AvatarSwitch.js';
import '@mui/icons-material/ArrowDropDown';
import 'date-fns/locale/pt-BR';
import '@mui/x-date-pickers/AdapterDateFns';
import '@mui/x-date-pickers/LocalizationProvider';
import '@mui/x-date-pickers/DatePicker';
import '../../../components/DateRange.js';
import '@mui/x-date-pickers/DateTimePicker';
import '../../../components/FilterDate.js';
import '../../../components/FullScreenBackdrop.js';
import '@mui/x-date-pickers/TimePicker';
import '../../../components/Label.js';
import '../../../components/LoadingScreen.js';
import { Logo } from '../../../components/Logo.js';
import '../../../components/OnlineIndicator.js';
import '../../../components/Page.js';
import '../../../components/QuantityInput.js';
import '../../../components/QuestionDialog.js';
import '@mui/icons-material/MoreVert';
import '@mui/icons-material/Edit';
import '@mui/icons-material/Delete';
import '../../../components/SplashScreen.js';
import '../../../components/StackAvatars.js';
import '../../../components/TitleBack.js';
import { NavItem } from './NavItem.js';
import '../../../utils/getItemLocalStorage.js';
import 'quagga';
import '../../../components/Loading.js';
import 'react-qr-reader';
import '../../../utils/getInitials.js';
import '../../../components/DatePicker.js';
import 'react-feather';
import 'clsx';
import 'nprogress';
import 'react-helmet';
import '../../../utils/analytics.js';
import 'react-number-format';
import '@mui/icons-material/ArrowBack';
import '@mui/icons-material/ExpandMore';
import '@mui/icons-material/ExpandLess';

const PREFIX = 'NavBar';
const classes = {
    mobileDrawer: `${PREFIX}-mobileDrawer`,
    desktopDrawer: `${PREFIX}-desktopDrawer`,
    link: `${PREFIX}-link`,
};
const Root = styled('div')(() => ({
    [`& .${classes.mobileDrawer}`]: {
        width: 256,
    },
    [`& .${classes.desktopDrawer}`]: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)',
    },
    [`& .${classes.link}`]: {
        textDecoration: 'none',
    },
}));
const renderNavItems = (_a) => {
    var { items } = _a, rest = __rest(_a, ["items"]);
    return (jsx(List, Object.assign({ disablePadding: true }, { children: items.reduce(
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        (acc, item) => reduceChildRoutes(Object.assign({ acc, item }, rest)), []) })));
};
const reduceChildRoutes = ({ acc, pathname, item, depth = 0, }) => {
    const key = item.title + depth;
    const visible = !item.direito || hasDireito(item.direito);
    if (visible) {
        if (item.items) {
            acc.push(jsx(NavItem, Object.assign({ depth: depth, icon: item.icon, open: false, title: item.title, linkExterno: item.linkExterno }, { children: renderNavItems({
                    depth: depth + 1,
                    pathname,
                    items: item.items,
                }) }), key));
        }
        else {
            acc.push(jsx(NavItem, { depth: depth, href: item.href, icon: item.icon, title: item.title, linkExterno: item.linkExterno }, key));
        }
    }
    return acc;
};
const NavBar = ({ openMobile, onMobileClose, navConfig }) => {
    const location = useLocation();
    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
    }, [location.pathname]);
    const content = (jsxs(Fragment, { children: [jsx(Box, Object.assign({ height: "100%", display: "flex", flexDirection: "column" }, { children: jsxs(PerfectScrollbar, Object.assign({ options: { suppressScrollX: true } }, { children: [jsx(Hidden, Object.assign({ lgUp: true }, { children: jsx(Box, Object.assign({ p: 2, display: "flex", justifyContent: "center" }, { children: jsx(Link, Object.assign({ to: "/" }, { children: jsx(Logo, {}) })) })) })), jsx(Box, Object.assign({ p: 2 }, { children: navConfig.nav.map(config => (jsx(List, Object.assign({ subheader: jsx(ListSubheader, Object.assign({ disableGutters: true, disableSticky: true }, { children: config.subheader })) }, { children: renderNavItems({
                                    items: config.items,
                                    pathname: location.pathname,
                                }) }), config.subheader))) }))] })) })), jsx(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", mt: 3 }, { children: jsx(Link$1, Object.assign({ href: "https://www.cigam.com.br", target: "_blank", underline: "hover" }, { children: jsx("img", { alt: "Desenvolvido por CIGAM", src: "/static/images/powered-cigam.png" }) })) }))] }));
    return (jsxs(Root, { children: [jsx(Hidden, Object.assign({ lgUp: true }, { children: jsx(Drawer, Object.assign({ anchor: "left", classes: { paper: classes.mobileDrawer }, onClose: onMobileClose, open: openMobile, variant: "temporary" }, { children: content })) })), jsx(Hidden, Object.assign({ lgDown: true }, { children: jsx(Drawer, Object.assign({ anchor: "left", classes: { paper: classes.desktopDrawer }, open: true, variant: "persistent" }, { children: content })) }))] }));
};

export { NavBar };
